import React from "react";
//#region types
import { FormFieldProps } from "models/propTypes/genericFormProps";
import { FormFieldConstants } from "utils/constants";
import { UtilFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { FormEnums } from "models/enums";
//#endregion
//#region components
import ReadOnlyField from "../baseFields/readOnlyField";
import * as FormFields from "../../forms/formFields";
import { Grid } from "@mui/material";
import { useFormikContext } from "formik";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { FormHelper } from "utils/helpers";

function NumberRangeFormField<T extends Record<string, any>>(props: FormFieldProps<T>) {
  const { name, field, value, readonly } = props;
  const { values } = useFormikContext<T>();

  const lowestFieldName = `${name}.${FormFieldConstants.Util.NumberRange.Lowest}`;
  const highestFieldName = `${name}.${FormFieldConstants.Util.NumberRange.Highest}`;

  const numberRangeValue = value as UtilFormTypes.NumberRange;

  const fieldType =
    field.type === FormEnums.FormFieldType.NUMBERRANGE
      ? FormEnums.FormFieldType.NUMBER
      : FormEnums.FormFieldType.CURRENCY;

  return readonly ? (
    <ReadOnlyField label={field.label} href={field.href} className={cssExports.readOnlyTextField}>
      {FormHelper.getFormattedValue(value, values, field)}
    </ReadOnlyField>
  ) : (
    <Grid container direction="row" spacing={1}>
      <Grid item xs={6}>
        <FormFields.InputFormField
          {...props}
          name={lowestFieldName}
          value={numberRangeValue?.lowest}
          field={{ ...field, label: TranslationKeys.Common.Lowest, type: fieldType }}
        />
      </Grid>
      <Grid item xs={6}>
        <FormFields.InputFormField
          {...props}
          name={highestFieldName}
          value={numberRangeValue?.highest}
          field={{ ...field, label: TranslationKeys.Common.Highest, type: fieldType }}
        />
      </Grid>
    </Grid>
  );
}

export default NumberRangeFormField;
